export default function noticeComponent() {
  const wrapper = document.querySelector('[data-js="notice-wrapper"]');
  if (!wrapper) return;

  const closeBtn = wrapper.querySelector('[data-js="notice-close"]');
  const version = wrapper.getAttribute('data-notice-version') || 'v1';
  const storageKey = 'notice_dismissed_version';

  const dismissedVersion = window.localStorage.getItem(storageKey);

  // If user already dismissed this exact version, keep it hidden
  if (dismissedVersion === version) {
    wrapper.setAttribute('hidden', 'true');
    return;
  }

  // Show
  wrapper.removeAttribute('hidden');

  const dismiss = () => {
    window.localStorage.setItem(storageKey, version);

    // Start collapse animation
    wrapper.classList.add('is-closing');

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion) {
      wrapper.setAttribute('hidden', 'true');
      wrapper.classList.remove('is-closing');
      return;
    }

    const onEnd = (e) => {
      if (e.target !== wrapper) return;
      if (e.propertyName !== 'max-height') return;

      wrapper.setAttribute('hidden', 'true');
      wrapper.classList.remove('is-closing');
      wrapper.removeEventListener('transitionend', onEnd);
    };

    wrapper.addEventListener('transitionend', onEnd);
  };

  closeBtn?.addEventListener('click', dismiss);
}
